import { createContext } from 'react';

export type CanEditFormFieldsContextProps = {
  isEditable: boolean;
};

export const CanEditFormFieldsContext = createContext<CanEditFormFieldsContextProps>({
  isEditable: true,
});
